module.exports = __webpack_public_path__ + "img/adp.88515ea5.svg";